import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { AutomatedMessageRuleValidation } from 'uplisting-frontend/validations';

export default class AutomatedMessageRuleRepositoryService extends BaseRepositoryService<
  ModelRegistry['automated-message-rule']
> {
  recordName = 'automated-message-rule';
  implementMethods = ['findAll', 'createRecord', 'buildChangeset'];

  validation = AutomatedMessageRuleValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/automated-message-rule': AutomatedMessageRuleRepositoryService;
  }
}
